<template>
  <div class="g-content device-model">
    <div class="g-content-filter model-alias-filter">
      <div class="g-content-filter-main">
        <h3>
          {{ $t('deviceModel_alias_title') }}
          <p>{{ $t('deviceModel_alias_description') }}</p>
        </h3>

        <div class="g-content-filter-right" v-if="!networkError">
          <a-button type="default" @click="isEdit = false" v-if="isEdit">
            {{ $t('com_btn_cancel_edit') }}
          </a-button>

          <a-button
            type="primary"
            @click="handleSave"
            icon="edit"
            v-if="isEdit"
            :loading="submitting"
          >
            {{ $t('com_btn_save') }}
          </a-button>

          <a-button
            type="default"
            @click="getAllModelList"
            v-if="!isEdit && hasEditAuth"
            :loading="loading"
          >
            {{ $t('com_btn_refresh') }}
          </a-button>
          <a-button type="primary" @click="handleEdit" icon="edit" v-if="!isEdit && hasEditAuth">
            {{ $t('com_btn_edit') }}
          </a-button>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main device-model-alias-main">
      <!-- <div v-if="!(aliasList && aliasList.length)" class="model-alias-empty">
        {{ $t('deviceModel_no_alias') }}
      </div> -->
      <div class="model-alias-main" v-if="modelList && modelList.length">
        <ul>
          <li>
            <div class="model-alias-item" style="background-color: #f5f5f5;font-weight: bold;">
              <div class="model-alias-column">{{ $t('deviceModel_original_name') }}</div>
              <div class="model-alias-column">{{ $t('deviceModel_alias_name') }}</div>
            </div>
          </li>
        </ul>
        <a-form-model :model="modelAliasForm" ref="modelAliasForm" class="model-alias-main-form">
          <TreeNode :nodes="modelList" :isEdit="isEdit" :form="modelAliasForm"></TreeNode>
        </a-form-model>
      </div>
      <NetworkError v-else-if="networkError" style="margin-top:0;" />
      <Empty v-else />
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/model';
import { makeTree } from '@/libs/utils';
import Config from '@/config';
import { mapGetters } from 'vuex';
import TreeNode from './TreeNode.vue';

export default {
  components: {
    TreeNode,
  },
  data() {
    return {
      Config,
      loading: true,
      networkError: false,
      allModelList: null,
      modelList: null,
      aliasList: null,
      modelAliasForm: {},
      isEdit: false,
      submitting: false,
      devModelIds: '',
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),

    // 是否有编辑权限
    hasEditAuth() {
      return (
        (this.authList.includes('auth_deviceModel_alias_list') &&
          this.authList.includes('auth_deviceModel_alias_update_batch')) ||
        this.isSuperAdmin
      );
    },
  },
  created() {
    this.getAllModelList();
  },
  beforeDestroy() {},
  methods: {
    // 获取模型列表
    getAllModelList() {
      this.loading = true;
      API.DeviceModelListAll()
        .then(res => {
          if (res.code === 0) {
            this.allModelList = res.data || [];

            this.devModelIds = this.allModelList.map(item => item.devModelId);

            this.getModelAliasList();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 获取模型别名列表
    getModelAliasList() {
      // 获取模型别名列表
      API.DeviceModelAliasList({
        devModelIds: this.devModelIds.join(','),
      })
        .then(response => {
          if (response.code === 0) {
            this.aliasList = response.data || [];
            this.allModelList.forEach(item => {
              item.alias = response.data.find(
                aliasItem => aliasItem.devModelId === item.devModelId
              )?.alias;
              this.$set(this.modelAliasForm, item.devModelId, item.alias);
            });

            const treeObj = makeTree({
              data: this.allModelList || [],
              idName: 'devModelId',
              parentIdName: 'parentId',
            });
            this.modelList = treeObj.array;

            this.isEdit = false;
          }
        })
        .catch(() => {
          this.$store.commit('setPageLoading', false);
          this.submitting = false;
          this.loading = false;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
          this.submitting = false;
          this.loading = false;
          this.isEdit = false;
        });
    },

    // 编辑
    handleEdit() {
      this.isEdit = true;
    },

    // 保存
    handleSave() {
      this.$refs.modelAliasForm.validate(valid => {
        if (valid) {
          const params = [];
          for (const key in this.modelAliasForm) {
            const _param = {
              devModelAlias: this.modelAliasForm[key] || '',
              devModelId: key,
            };
            params.push(_param);
          }
          this.submitting = true;

          API.DeviceModelAliasUpdates(params)
            .then(res => {
              if (res.code === 0) {
                this.getModelAliasList();
                this.$message.success(this.$t('com_msg_save_success'));
              } else {
                this.$message.error(this.$t('com_msg_save_fail'));
                this.submitting = false;
              }
            })
            .catch(() => {
              this.submitting = false;
              this.$message.error(this.$t('com_msg_save_fail'));
            });
        }
      });
      return false;
    },
  },
};
</script>
<style lang="less" scoped>
.model-alias-filter {
  height: auto !important;

  .g-content-filter-main {
    padding: 16px 24px !important;
    margin: 0 !important;
    h3 {
      p {
        font-weight: normal;
        font-size: 16px;
        margin: 0;
        padding: 10px 0;
      }
    }
  }
}
// .g-content.device-model {
//   display: flex;
//   flex-direction: column;
// }
.g-content {
  padding: 0;
  .model-alias-empty {
    text-align: center;
    padding: 20px;
    font-size: 20px;
    color: #666;
  }
  .device-model-alias-main {
    height: calc(100% - 84px - 40px) !important;
  }
  ::v-deep .model-alias-main {
    height: 100%;
    max-width: 70%;
    margin: 0 auto;
    width: 100%;
    padding-bottom: 12px;
    .model-alias-main-form {
      padding-bottom: 20px;
    }
    .model-alias-item {
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 16px;

      .model-alias-column {
        padding: 15px 10px;
        display: block;

        &:first-child {
          flex: 1;
        }

        &:last-child {
          width: 50%;
          border-left: #ccc solid 1px;
        }
      }
    }

    /* 为整个列表设置表格效果 */
    ul {
      list-style-type: none; /* 移除默认的项目符号 */
      border-collapse: collapse;
      padding: 0;
      margin: 0;
      border-top: 1px solid #ccc; /* 表格边框 */
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;

      li {
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        flex-direction: column;

        &:last-child {
          border-bottom: none; /* 移除最后一行的边框 */
        }
      }

      > li {
        padding-left: 0; /* 顶层无缩进 */
        ins {
          font-style: normal;
          text-decoration: none;
        }
      }

      ul {
        margin: 0; /* 移除嵌套ul的默认间距 */
        padding: 0;
        border-left: none;
        border-right: none;
        border-bottom: none;
        width: 100%;

        li {
          ins {
            font-style: normal;
            padding-left: 20px;
            text-decoration: none;
          }
        }
      }
    }
  }
}
</style>
